import { render, staticRenderFns } from "./video.vue?vue&type=template&id=d5c4855a&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"
import style0 from "./video.vue?vue&type=style&index=0&id=d5c4855a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c4855a",
  null
  
)

export default component.exports